import { EXTERNAL_SETTINGS_MODIFY } from "../actions/externalSettings"

const initialState = {
  integrations: [],
  isFetched: false,
  error: null,
  isSaving: false,

  integrationsConfig: {},
  isFetchedConfig: false,
  errorConfigs: null,
  isSavingConfig: false
}

export default function externalSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case EXTERNAL_SETTINGS_MODIFY:
      return Object.assign({}, state, action.payload)

    default:
      return state
  }
}
